module.exports = __webpack_public_path__ + "static/media/lvjian-zhinengzhizao.3afd5062.png";